export const dialogPaperProps = {
	sx: {
		width: 418,
		height: 190,
		borderRadius: '8px',
		padding: '16px',
	},
} as const;
